<!-- MIT License

Copyright (c) 2024 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. -->

<div class="confirm">
  <h1 mat-dialog-title class="heading">Remove Passkey?</h1>
  @if (pkState==NONE_PK) {
    <div class="message" mat-dialog-content>
      Once removed, this passkey will no longer identify you with Quick Crypt.
      The passkey cannot be added back and you should also delete it
      from your passkey managment tool. You may continue accessing Quick Crypt
      with your remaining passkeys.<br /><br />
      Continue with passkey removal?
    </div>
  }
  @if (pkState==ACTIVE_PK) {
    <div class="message" mat-dialog-content>
      This is the passkey you used to sign-in to Quick Crypt. Removing it
      will sign you out and you'll need to use another passkey to sign in.
      The deleted passkey cannot be added back and you should also delete it
      from your passkey managment tool.<br /><br />
      Continue with passkey removal?
    </div>
  }
  @if (pkState==LAST_PK) {
    <div class="message" mat-dialog-content>
      Deleting your only passkey will remove your entire user identify and
      you will not be able to decrypt previously encypted data with the
      Quick Crypt website. Removing this passkey and user identify are
      irriversable and your recovery link will only work with command-line tools.
      If you proceed, also delete this passkey from your passkey managment tool.<br /><br />
      To continue, type '{{userName}}' then click Yes.
      <div>
        <mat-form-field class="extra-input" subscriptSizing="dynamic">
          <input id="confirmInput" type="text" matInput [(ngModel)]="confirmInput" required
            placeholder="user name"
            />
        </mat-form-field>
      </div>
    </div>
  }

  <div class="actions" mat-dialog-actions>
    <button mat-button (click)="onYesClicked()">Yes</button>
    <button mat-button mat-dialog-close>No</button>
  </div>
</div>